export class IdentificacaoModel {
    constructor() {
        this.Sucesso = false;
    }

    public Sucesso: boolean;
    public Mensagem: string;
    public Id: string;
    public EmpresaAtiva: boolean;
    public PermiteCriarPedido: boolean;
    public CodigoMesa: string;
    public CodigoMesaCripto: string;
    public EhDispositivoVinculado: boolean;
    public VinculoTablet: boolean;
    public ExibirAoConsumidor: boolean;
    public UrlChamadoraAjustada: string;
}